import { ConfigurationId, FundListingComponentType } from '@types';
import { FundListingDisplayComponent } from './fund-listing-display-component.interface';
import { Type } from '@angular/core';
import { FundListingComponent } from './fund-listing/fund-listing.component';
import { FundCardsComponent } from './fund-cards/fund-cards.component';
import { HomeFundListingComponent } from "./home-fund-listing/home-fund-listing.component";
import { FundCompareComponent } from "@products/fund-listing/fund-compare/fund-compare.component";
import { FundWatchListComponent } from './fund-watch-list/fund-watch-list.component';

export class FundListingComponentConfig {
  static readonly PPSS = new FundListingComponentConfig(
    FundListingComponentType.PPSS,
    FundListingComponent
  );
  static readonly PPSS_HOME_LISTING = new FundListingComponentConfig(
    FundListingComponentType.HOME_LISTING,
    HomeFundListingComponent
  );
  static readonly LATEST_NAVS = new FundListingComponentConfig(
    FundListingComponentType.NAV,
    FundListingComponent
  );

  static readonly FUND_CARDS = new FundListingComponentConfig(
    FundListingComponentType.FUNDCARDS,
    FundCardsComponent
  );

  static readonly FUND_COMPARE = new FundListingComponentConfig(
    FundListingComponentType.FUNDCOMPARE,
    FundCompareComponent
  );

  static readonly FUND_WATCH_LIST = new FundListingComponentConfig(
    FundListingComponentType.FUNDWATCHLIST,
    FundWatchListComponent
  );

  static allConfigs: FundListingComponentConfig[] = [
    FundListingComponentConfig.PPSS,
    FundListingComponentConfig.PPSS_HOME_LISTING,
    FundListingComponentConfig.LATEST_NAVS,
    FundListingComponentConfig.FUND_CARDS,
    FundListingComponentConfig.FUND_COMPARE,
    FundListingComponentConfig.FUND_WATCH_LIST
  ];

  // returns matching config or undefined
  static getConfig(
    componentType: FundListingComponentType,
    configurationName?: ConfigurationId
  ): FundListingComponentConfig {
    return this.allConfigs.find((config: FundListingComponentConfig): boolean =>
      config.configurationName
        ? config.componentType === componentType &&
          config.configurationName === configurationName // if config is GW or ETF specific,make sure it matches
        : config.componentType === componentType
    ); // otherwise just match on key
  }

  private constructor(
    public readonly componentType: FundListingComponentType,
    public readonly component: Type<FundListingDisplayComponent>,
    public readonly configurationName?: ConfigurationId
  ) {}
}
